// extracted by mini-css-extract-plugin
module.exports = {"previewSpinner":"Loader_previewSpinner__3xRyb","previewSpinnerAnimation":"Loader_previewSpinnerAnimation__6yjxl"};